import { mockMaintenanceTask } from "mocks/mock-maintenance-tasks";
import { type MaintenanceTask } from "types/maintenance-task";
import { type MaintenancePaginationMeta } from "types/pagination";
import { apiClient } from "utils/api-client/index";
import { createModel } from "utils/models";

export type MaintenanceTaskStatusFilter = "active" | "past";

export type LandlordMaintenanceData = {
  data: MaintenanceTask[];
  pagination: MaintenancePaginationMeta;
};

export type LandlordPropertySelectorData = {
  data: PropertySelectorData[];
};

type PropertySelectorData = {
  id: string;
  display_name: string;
};

export const landlordPropertySelector = createModel(
  "landlordPropertySelector",
  {
    queries: {
      read: (ownershipId: string) => ({
        queryKey: ["read", "landlord-property-selector", ownershipId],
        queryFn: () => {
          return apiClient.get<LandlordPropertySelectorData>(
            `landlord-portal/${ownershipId}/properties`,
          );
        },
        enabled: !!ownershipId,
      }),
    },
  },
);

export const landlordMaintenanceTask = createModel("landlordMaintenanceTask", {
  infiniteQueries: {
    read: (
      ownershipId: string,
      status: MaintenanceTaskStatusFilter,
      propertyId?: string | null,
    ) => ({
      queryKey: [
        "landlord-maintenance-task",
        ownershipId,
        status,
        propertyId ?? null,
      ],
      queryFn: ({ pageParam }: { pageParam: number }) => {
        return apiClient.get<LandlordMaintenanceData>(
          `/landlord-portal/${ownershipId}/maintenance-tasks`,
          {
            status,
            page: pageParam,
            ...(propertyId ? { property_id: propertyId } : {}),
          },
        );
      },
      initialPageParam: 1,
      getNextPageParam: (lastPage: LandlordMaintenanceData) =>
        lastPage.pagination.current_page < lastPage.pagination.total_pages
          ? lastPage.pagination.current_page + 1
          : undefined,
      enabled: !!ownershipId,
    }),
  },
});

export const mockLandlordMaintenanceResponse = (): LandlordMaintenanceData => ({
  data: Array.from({ length: 10 }).map(() => mockMaintenanceTask()),
  pagination: {
    total: 10,
    count: 10,
    per_page: 10,
    current_page: 1,
    total_pages: 1,
    links: [],
  },
});
